import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26d88202"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loader"
}, null, -1));
const _hoisted_2 = [_hoisted_1];
import { ref } from 'vue';
export default {
  __name: 'LoadingView',
  setup(__props, {
    expose: __expose
  }) {
    const isLoading = ref('display-none');
    // 显示弹出框
    const show = () => {
      isLoading.value = 'display-flex';
    };

    // 关闭弹出框
    const close = () => {
      isLoading.value = 'display-none';
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "loading",
        class: _normalizeClass(isLoading.value)
      }, _hoisted_2, 2);
    };
  }
};